// Minimal types for inputs coming from API/UI
export type StudyStatus = "in_progress" | "completed" | "on_hold" | "dropped";

export interface AcademicPeriodInput {
  status?: StudyStatus | null;
  started_at?: string | null;               // "YYYY-MM" (or undefined/null)
  expected_graduation_at?: string | null;   // "YYYY-MM"
  graduated_at?: string | null;             // "YYYY-MM"
}

/** Format "YYYY-MM" => "YYYY Mon" (e.g., "2025 Nov"). Returns null if invalid. */
export function formatYearMonthLabel(ym?: string | null): string | null {
  if (!ym || typeof ym !== "string" || ym.length < 7) return null;
  const [yStr, mStr] = ym.split("-");
  const y = Number(yStr);
  const m = Number(mStr);
  if (!y || !m || m < 1 || m > 12) return null;
  const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  return `${y} ${MONTHS[m - 1]}`;
}

/** Compact period label based on status + year-month fields. */
export function compactAcademicPeriod(ar: AcademicPeriodInput): string {
  const start = formatYearMonthLabel(ar.started_at);
  const exp   = formatYearMonthLabel(ar.expected_graduation_at);
  const grad  = formatYearMonthLabel(ar.graduated_at);

  switch (ar.status) {
    case "in_progress":
      return `${start ?? "—"} – present${exp ? ` (expected ${exp})` : ""}`;
    case "completed":
      return grad ? (start ? `${start} – ${grad}` : `${grad}`) : (start ?? "—");
    case "on_hold":
      return `${start ?? "—"} – on hold${exp ? ` (expected ${exp})` : ""}`;
    case "dropped":
      return `${start ?? "—"} – dropped`;
    default:
      return start ?? grad ?? "—";
  }
}
